export { default } from './ImageLoader';
